<h3><a ng-click="viewDetails($event, item)">{{ item.name }}</a> <span ng-if="!item.active">{{"centuriList.inactive"|translate}}</span></span></h3>
<div>
    <span>{{ item.prefix }}1{{ item.suffix }}</span>
</div>
